import { storage } from 'lib/firebaseService';
import { uuidv4 } from '@firebase/util';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

export const useUploadFile = () => {
  return async (image?: File | null) => {
    if (!image) return '';
    const storageRef = ref(storage, uuidv4() + image.name);
    return uploadBytes(storageRef, image).then((snapshot) => {
      return getDownloadURL(snapshot.ref);
    });
  };
};
